import React from 'react'
import { Button } from 'antd'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import { useTranslation } from '@/libs/next-lang'
import { getGlobalRedirectPath } from '@/utils'
import IconSvg from '@/components/IconSvg'
import styles from './index.module.less'

const UnPermission = (props: any) => {
  const history = useRouter()
  const { t } = useTranslation(['components'])

  return (
    <div className={styles.unPermission}>
      <IconSvg className={styles.unPermissionIcon} type="icon-assets-403" />
      <div className={classNames(styles.text, styles.title)}>
        {/* {`当前账号${props.name || ''}暂无${props.page || ''}页面的查看权限`} */}
        {t('components:t11')}
      </div>
      <div className={styles.text}>{t('components:t12')}</div>
      <div className={styles.text}>{t('components:t13')}</div>
      <div className={styles.backHome}>
        <Button
          type="primary"
          onClick={() => {
            history.push(getGlobalRedirectPath())
          }}
        >
          {t('components:t14')}
        </Button>
      </div>
    </div>
  )
}
export default UnPermission
